import { render, staticRenderFns } from "./OrdersAndCouriersMap.vue?vue&type=template&id=190eb239&scoped=true&"
import script from "./OrdersAndCouriersMap.vue?vue&type=script&lang=js&"
export * from "./OrdersAndCouriersMap.vue?vue&type=script&lang=js&"
import style0 from "./OrdersAndCouriersMap.vue?vue&type=style&index=0&id=190eb239&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190eb239",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VContainer,VIcon,VList,VListItem,VMenu,VSwitch})
